module.exports = __webpack_public_path__ + "img/delete.e0fcd9ff.svg";